import React from "react";
import SSScoreNeedle from "./ssscoreneedle";
import { ReactComponent as Gauge } from "../../../../../assets/svgs/websvgs/scoreValue.svg";
import "./ssscoredialler.css";

class SSScoreDialler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className={"sss_viewStyle"}>
        <svg
          width="211"
          height="166"
          viewBox="0 0 211 166"
          fill="none"
          className={"sss_diallerViewStyle"}
          xmlns="http://www.w3.org/2000/svg"
        >
          <SSScoreNeedle
            size={200}
            currentValue={this.props.value}
            needleSharp={true}
            needleColor={this.props.needleColor}
            progressFontSize={12}
            needleBaseSize={9.5}
            needleBaseColor={this.props.needleBaseColor}
            needleWidth={8}
          />
        </svg>
        <div className="sss_valueViewStyle">
          <Gauge />
        </div>
      </div>
    );
  }
}

export default SSScoreDialler;
